// jshint esversion: 6
/**
 * Selectors
 */
const $headerFixed = $('.site-header');
const $socialBar = $('.social-bar');

/**
 * Methods
 */
function fixedHeaderResize () {
	let scroll = getCurrentScroll();
	if ( scroll >= $headerFixed.innerHeight()/7 ) {
		$headerFixed.addClass('small');
		$socialBar.slideUp();
	} else {
		$headerFixed.removeClass('small');
		$socialBar.slideDown();
	}
}

/**
 * Detect homepage
 */
var is_homepage = $('body').hasClass('home');

/**
 * Events/init
 */
if ( $headerFixed.length && is_homepage ) {
	window.addEventListener( 'scroll', fixedHeaderResize, false );
}

function getCurrentScroll () {
	return window.pageYOffset || document.documentElement.scrollTop;
}
